export { default as useFinInfiniteCategories } from './useFinInfiniteCategories';
